export interface OrderEditSession {
  orderId: string
  previousCartId: string
  originalQuantities: Record<string, number>
}

const STORAGE_KEY = 'orderEditSession'

export function getOrderEditSessionFromStorage(): OrderEditSession | null {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    const data = JSON.parse(raw)
    if (!data.orderId) {
      return null
    }
    return {
      orderId: data.orderId,
      previousCartId: data.previousCartId || '',
      originalQuantities: data.originalQuantities || {},
    }
  } catch {
    return null
  }
}

export function saveOrderEditSessionToStorage(session: OrderEditSession): void {
  if (typeof window === 'undefined') {
    return
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export function deleteOrderEditSessionFromStorage(): void {
  if (typeof window === 'undefined') {
    return
  }
  localStorage.removeItem(STORAGE_KEY)
}
